import {Picture} from "./picture";
import {User} from "./user";

export class FamilyAlbum {

    bannerUrl:string;
    bannerHDUrl: String;

    businessId: number;

    codeActivated:boolean = false;

    creationDate:number;

    date:number;

    filesNumber:number;

    id:number;

    public:boolean = false;

    members:User[];

    name:string;

    pictures:Picture[];

    nbComments:number;

    invitationCode: string;

    memberLimit: number;

    premiumType:string;

    manualValidation: boolean;

    followingTag: String;

    clone():any {
        var cloneObj = new (<any>this.constructor());
        for (var attribut in this) {
            if (typeof this[attribut] === "object") {
                cloneObj[attribut] = this.clone();
            } else {
                cloneObj[attribut] = this[attribut];
            }
        }
        return cloneObj;
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/family-album.ts